export default __webpack_public_path__ + "static/main_reversed-poster-e026fe471b53f6909fa9c70586a10934.avif";